import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'

import { OVERALL_SUB_CATEGORY } from '../../../model/constants'
import type { SobTableEntry } from '../../../model/types'
import type { SobTableTitlePlacement } from '../sobActualsTable/SobActualsTable'
import { sobActualsTableTranslation } from '../sobActualsTable/translation'

import styles from './SobActualsHierarchy.module.scss'

type SobActualsHierarchyProps = {
  overallTableEntry?: SobTableEntry
  subCategoryTableEntries: SobTableEntry[]
  renderTable: (
    entry: SobTableEntry,
    title?: string,
    titlePlacement?: SobTableTitlePlacement
  ) => JSX.Element
}

export const SobActualsHierarchy = ({
  overallTableEntry,
  subCategoryTableEntries,
  renderTable,
}: SobActualsHierarchyProps): JSX.Element => {
  const [t] = useTranslation()
  const category = overallTableEntry?.category ?? subCategoryTableEntries[0]?.category
  const categoryTitle =
    category && category !== OVERALL_SUB_CATEGORY
      ? `${t(category)} ${t(sobActualsTableTranslation.overall)}`
      : undefined

  return (
    <div className={styles.root}>
      {overallTableEntry && (
        <section>{renderTable(overallTableEntry, categoryTitle, 'header')}</section>
      )}

      <div className={styles.divider} />
      <div className={styles.subList}>
        {subCategoryTableEntries.map((entry) => (
          <section key={entry.key} className={styles.subSection}>
            <div className={styles.subTable}>{renderTable(entry, entry.title)}</div>
            {!!entry.childEntries?.length && (
              <div className={styles.l3List}>
                {entry.childEntries.map((childEntry) => (
                  <div key={childEntry.key} className={styles.l3Table}>
                    {renderTable(childEntry, childEntry.title)}
                  </div>
                ))}
              </div>
            )}
          </section>
        ))}
      </div>
    </div>
  )
}
